/* eslint-disable max-len */
/* eslint-disable no-console */
import React from 'react';
import { Box, Grid, Tooltip, MenuItem, Select, Divider, FormControlLabel, Checkbox, RadioGroup, Radio } from '@mui/material';
import ChargeBalance from './charge-balance';

import { getNFfeedAndCLROFrom } from '../../shared/Products';
import { ialertInfo } from '../../shared/assets/images';
// shared
import { waterType, waterSource, } from '../../shared/constantVariable';

import './feed-analysis.scss';
import FeedUploadFile from './FeedUploadFile';

const FeedType = (props) => {
  const { handleChangeWaterType, isWaterAnalysis, waterTypeObj, balanceObj, handleChangeChargeBalance, handleChangeWaterComposition,
    compositionType, handleIonChange,
    chargeBalanceIon, isShowNF_Feed, dbTransactionDetails,
    handleNF_feedChanges, rowData, setRowData, setDisableBalance, params, setParams, setCations, setAnions, setpdfdropdown, setpdfDdMenuItem,
    setFileUploadStatus, fileUploadStatus, pdfDdMenuItem, pdfdropdown, handleChangePdfRes, inputMode, translateObject, units } = props;
  const isshowNFFeed = getNFfeedAndCLROFrom(dbTransactionDetails);
  const { composition } = compositionType;

  return (
    <Box sx={{ flexGrow: 1 }} className='feed-analysis-body'>
      <Grid container spacing={2} style={{ marginTop: '0px', marginLeft: '0px' }}>
        {isWaterAnalysis && <Grid item xs={12} style={{ paddingLeft: '0px', paddingTop: '0px' }}>
          <div className='feed-analysis-header rufusBld no_drag M_heading secoundary-text-color-Primary-default'>
            {translateObject('Feed Water Analysis')}</div>
        </Grid>}
        <Grid item xs={12} sm={12} md={6} lg={12} style={{ 'marginLeft': '0px', paddingLeft: '0px', paddingTop: '0px', marginTop: isWaterAnalysis ? '32px' : '0px' }}>
          {isWaterAnalysis && <Grid item xs={12} className=''>
            <div className="input-select-grid-feedForm">
              <div className="normal-font f-left sansW6SeBld no_drag S_Bold forground-text-primary">{translateObject('Select Water Source')}</div>
              <div className='select-dropdown no_drag'>
                <Select
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  value={waterTypeObj.waterSource}
                  name='waterSource'
                  style={{ width: '90%', height: '32px' }}
                  fullWidth
                  onChange={handleChangeWaterType}
                  data-testid='waterSource'>
                  {(waterSource || []).map((val) => (
                    <MenuItem key={val.id}
                      value={val.id}>{translateObject(val.name)}</MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </Grid>}
          {isWaterAnalysis && <Grid item xs={12} className={`${isShowNF_Feed ? 'is-disabled' : ''}`} style={{ marginTop: '16px' }}>
            <div className="input-select-grid-feedForm">
              <div className="normal-font f-left sansW6SeBld no_drag S_Bold forground-text-primary">{translateObject('Select Water Type')}</div>
              <div className='select-dropdown no_drag'>
                <Select
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  value={waterTypeObj.waterType}
                  name='waterType'
                  style={{ width: '90%', height: '32px' }}
                  fullWidth
                  onChange={handleChangeWaterType}
                  data-testid='waterType'
                >
                  {(waterType || []).map((val) => (
                    <MenuItem key={val.id}
                      value={val.id}>
                      {translateObject(val.name)}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </Grid>}
          {!isWaterAnalysis && <RadioGroup
            column
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            className="radio-group-container no_drag S_Regular"
            style={{ flexDirection: 'column !important', alignContent: 'flex-start', justifyContent: 'center', alignItems: 'flex-start' }}
            value={composition}
            onChange={handleChangeWaterComposition}>
            <FormControlLabel
              name="composition"
              value="feed"
              control={<Radio />}
              label="Feed Composition"
              labelPlacement="end"
              className='ml-0 mr-0 sansW4SeLig'
            />
            <FormControlLabel
              name="composition"
              value="concentrate"
              control={<Radio />}
              label="Concentrate Composition"
              labelPlacement="End"
              className='ml-0 sansW4SeLig'
              style={{ 'marginRight': '1%' }}
            />
          </RadioGroup>}
        </Grid>
        {/* Added textrect by Abhishek */}
        <Grid item xs={12} sm={12} md={6} lg={12} style={{ 'marginLeft': '0px', paddingLeft: '0px', paddingTop: '0px' }}
          className={`${isShowNF_Feed ? 'is-disabled' : ''}`}>
          <div>
            <FeedUploadFile
              units={units}
              rowData={rowData}
              setRowData={setRowData}
              setDisableBalance={setDisableBalance}
              params={params}
              setParams={setParams}
              setCations={setCations}
              setAnions={setAnions}
              setpdfdropdown={setpdfdropdown}
              setpdfDdMenuItem={setpdfDdMenuItem}
              setFileUploadStatus={setFileUploadStatus}
              inputMode={inputMode}
              translateObject={translateObject}
            />
            <Tooltip style={{ display: 'none' }} title="Upload files in .xls / .xlsx / .csv format" placement="right" arrow>
              <img
                src={ialertInfo}
                alt="info"
                style={{ width: '14px', 'paddingLeft': '1px', 'position': 'relative', 'marginTop': '-0.4%', display: 'none' }}
                className="pointer"
              />
            </Tooltip>
            <span style={{ 'marginLeft': '3.8%', 'marginTop': '15px', 'fontFamily': 'sans W4SeLig', 'fontSize': '14px', display: 'none' }}>
              {fileUploadStatus}</span>

            {pdfDdMenuItem.length > 1 &&
              <div id='multidictRes' style={{ // eslint-disable-next-line
                'fontSize': '14px', 'fontFamily': 'sans W4SeLig', 'margin': '16px 0 14px 0',
                'color': '#fff', 'width': '97%'
              }}>
                <b>Multiple water samples are available in the report uploaded,
                  Please select the sample to be used from the follwing dropdown</b>
              </div>
            }
          </div>
          {/* PDF Dropdown start */}
          {(pdfDdMenuItem.length > 1) && <div className="input-select-grid-feedForm">
            <div className="normal-font f-left mt-2 sansW6SeBld" style={{
              'marginLeft': '3%'
            }}>{translateObject('Select_Water_Sample')}</div>
            <div className='select-dropdown'>
              <Select
                sx={{ width: '92%' }}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                value={pdfdropdown}
                name='pdfdropdown'
                onChange={handleChangePdfRes}
                data-testid='waterSource'>

                {pdfDdMenuItem.length > 1 &&
                  (pdfDdMenuItem).map((val, ind) => (
                    <MenuItem key={ind}
                      value={val}>{translateObject(val)}</MenuItem>
                  ))
                }
              </Select>
            </div>
          </div>}
          {/* PDF Dropdown end */}
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={12} className={`${isShowNF_Feed ? 'is-disabled' : ''}`}
          style={{ paddingLeft: '0px', paddingTop: '0px' }}>
          <div className="pH-checkbox borderd-content">
            <div className="title no_drag M_Bold forground-text-primary" data-testid="div-cb ">{translateObject('Charge Balance')}</div>
            <div className="content sansW4SeLig">
              <FormControlLabel
                value={chargeBalanceIon}
                control={
                  <Checkbox
                    checked={chargeBalanceIon}
                    onChange={handleIonChange}
                    data-testid='chargebalance-pH'
                    sx={{
                      color: '#2C2C2C',
                      '&.Mui-checked': {
                        color: '#00AEC74D',
                      },
                    }}
                  />}
                label="pH"
                className='feed-cbox no_drag'
                labelPlacement="end"
              />
              <Divider className='divider-text sansW7Bld no_drag'>{translateObject('OR')}</Divider>
              <Grid item xs={12} className={`mt-4 ${chargeBalanceIon || isShowNF_Feed ? 'is-disabled' : ''}`}>
                <ChargeBalance
                  handleChangeChargeBalance={handleChangeChargeBalance}
                  balanceObj={balanceObj}
                  translateObject={translateObject}
                />
              </Grid>
            </div>
          </div>
        </Grid>
        {isWaterAnalysis && <div style={{ display: isshowNFFeed ? 'block' : 'none' }}>
          <FormControlLabel
            value={isShowNF_Feed}
            control={
              <Checkbox
                checked={isShowNF_Feed}
                onChange={handleNF_feedChanges}
                data-testid='chargebalance-pH'
                sx={{
                  color: '#2C2C2C',
                  '&.Mui-checked': {
                    color: '#00AEC74D',
                  },
                }}
              />}
            label="NF Feed"
            className='feed-cbox no_drag'
            labelPlacement="end"
          />
        </div>}
      </Grid>
    </Box>
  );
};

export default FeedType;
